export default {
    namespaced: true,
    state: {
        FormPaySender: {
            nameSender: '',
            emailSender: '',
            telSender: null,
            donation: 5000,
            quantity: 1,
            regionSender: '',
            comunaSender: '',
        },
        FormPayReceiver: {
            nameReceiver: '',
            emailReceiver: '',
            telReceiver: null,
            calleReceiver: '',
            ncalleReceiver: '',
            villaReceiver: '',
            regionReceiver: '',
            comunaReceiver: '',
        },
        Factura: {
            phone: null,
            rut: '',
            razon_social: '',
            encargado: '',
            email_coorporativo: '',
            direction: '',
            giro: '',
        },
        FormValidation: { sender: false, Receiver: false },
    },
    mutations: {
        price(state, value) {
            state.FormPaySender.donation = value
        },
    },
    getters: {},

    actions: {
        price: function (context, value) {
            context.commit('price', value)
        },
    },
}
